import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, ModuleFE_MouseInteractivity, mouseInteractivity_ToolTip, openContent } from '@nu-art/thunderstorm-frontend';
import { Component_ContentFallback } from '../../Component_ContentFallback/Component_ContentFallback.js';
import './Component_FindingsButton.scss';
import { RuntimeOrderStatus_Enum } from '@app/advisor-shared';
import { ModuleFE_Advisor_Action, ModuleFE_Advisor_Resource, ModuleFE_EMInterface, ModuleFE_RuntimeFinding, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { filterInstances, sortArray } from '@nu-art/ts-common';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_Findings, PanelKey_Home } from '@app/advisor-v5-shared';
import { ICONS } from '@app/styles';
import { ModuleFE_PanelFindings } from '../../../../modules/ModuleFE_PanelFindings/ModuleFE_PanelFindings.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
export class Component_FindingsButton extends ComponentSync {
    //######################### Static #########################
    static modulesToAwait = [
        //Static Modules
        ModuleFE_Advisor_Action,
        ModuleFE_Advisor_Resource,
        //Runtime Modules
        ModuleFE_RuntimeOrder,
        ModuleFE_RuntimeFinding,
    ];
    //######################### Life Cycle #########################
    __onAdvisorMiniChange = () => {
        if (this.mounted)
            this.forceUpdate();
    };
    __onRuntimeOrdersUpdated = (...params) => {
        this.setState({ resultedOrders: this.getResultedOrders() });
    };
    deriveStateFromProps(nextProps, state) {
        state.forceFallback = !!nextProps.forceFallback;
        state.resultedOrders ??= this.getResultedOrders();
        return state;
    }
    resolveTooltipProps = () => {
        if (this.state.resultedOrders.length)
            return openContent.tooltip.top('tt__findings-button', this.render_TooltipContent(this.state.resultedOrders), { offset: 10 });
        if (!this.state.forceFallback)
            return;
        return openContent.tooltip.top('tt__findings-button', 'Findings', { offset: 10 });
    };
    //######################### Logic #########################
    getResultedOrders() {
        return sortArray(filterInstances(ModuleFE_RuntimeOrder.cache.map(rtOrder => {
            if (rtOrder.orderStatus !== RuntimeOrderStatus_Enum.RESULTED)
                return;
            const dbOrder = ModuleFE_Advisor_Action.cache.unique(rtOrder.orderId);
            if (!dbOrder)
                return;
            const resource = ModuleFE_Advisor_Action.is.order(dbOrder) ? ModuleFE_Advisor_Resource.cache.unique(dbOrder.resourceId) : undefined;
            if (!resource)
                return;
            return { rtOrder, dbOrder, resource };
        })), i => i.rtOrder.timeResulted);
    }
    onClick = async () => {
        const orders = this.state.resultedOrders;
        if (!orders.length) { //Toggle findings panel
            if (ModuleFE_AdvisorMini.getCurrentFocusedPanel() === PanelKey_Findings)
                return ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
            //Open findings and fall through to report analytics
            ModuleFE_AdvisorMini.openPanel(PanelKey_Findings);
        }
        else { //Promote orders and jump to order findings
            //Close tooltip
            ModuleFE_MouseInteractivity.hide(mouseInteractivity_ToolTip);
            //jump to the finding for the first order that has findings
            for (const order of orders)
                if (ModuleFE_PanelFindings.jumpToFinding(order.rtOrder._id))
                    break;
            //Promote All rtOrders to "completed"
            try {
                await ModuleFE_EMInterface.vv1.orders.completeOrders({ runtimeOrderIds: orders.map(i => i.rtOrder._id) }).executeSync();
            }
            catch (err) {
                this.logError('Failed to advance orders to "Completed"');
            }
        }
        const view = ModuleFE_PanelFindings.getCurrentOnScreenView();
        ModuleFE_AdvisorAnalytics.trigger.findings.findings_open({
            method: 'manual',
            viewId: view._id,
            viewLabel: view.label,
        });
    };
    getResourceIcon = (resource) => {
        switch (resource.type) {
            case 'EKG':
                return ICONS.advisor_avn_ekg;
            case 'Imaging':
                return ICONS.advisor_avn_imaging;
            case 'Laboratory':
                return ICONS.advisor_avn_labs;
            case 'Procedures':
                return ICONS.advisor_avn_medication;
            case 'Consultations':
                return ICONS.advisor_v5_form;
        }
    };
    //######################### Render #########################
    render() {
        const className = _className('c__findings-button', 'c__utility-button', ModuleFE_AdvisorMini.getCurrentFocusedPanel() === PanelKey_Findings && 'active');
        return _jsxs(Button, { className: className, variant: 'primary', onClick: this.onClick, ...this.resolveTooltipProps(), children: [_jsx(Component_ContentFallback, { forceFallback: this.state.forceFallback, content: () => 'Findings', fallback: () => _jsx(ICONS.advisor_avn_findings.component, {}) }), this.render_NotificationCount()] });
    }
    render_NotificationCount = () => {
        const count = this.state.resultedOrders.length;
        if (!count)
            return;
        return _jsx("div", { className: 'c__findings-button__count', children: count });
    };
    render_TooltipContent = (orders) => {
        return orders.map(order => {
            const Icon = this.getResourceIcon(order.resource);
            return _jsxs(LL_H_C, { children: [_jsx(Icon.component, {}), order.dbOrder.label || order.dbOrder.name] }, order.rtOrder._id);
        });
    };
}
//# sourceMappingURL=Component_FindingsButton.js.map